import ResponsiveTypography from '@/components/ui/responsive-typography';
import {useTranslation} from 'react-i18next';

interface NoMemberInfoProps {
  componentType: string;
}
const NoMemberInfo: React.FC<NoMemberInfoProps> = ({componentType}) => {
  const {t} = useTranslation();

  const messageText =
    componentType === 'event'
      ? 'join_event_to_see_chat'
      : 'join_group_to_see_chat';

  return <ResponsiveTypography>{t(messageText)}</ResponsiveTypography>;
};

export default NoMemberInfo;
